<template>
  <div class="flex justify-center">
    <Transition name="fade-transition">
      <MaintenanceToaster
        v-if="maintenanceConfig"
        :text="maintenanceConfig.text"
        :image-src="maintenanceConfig.image_src"
      />
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { injectAppContext } from '@shared/app-context';
  import {
    firebaseEntity,
    type MaintenanceToasterConfig,
  } from '@entities/firebase';
  import MaintenanceToaster from './MaintenanceToaster.vue';

  const appContext = injectAppContext();
  const firebase = firebaseEntity.model.useFirebase();

  const getLocalizedConfig = (config: MaintenanceToasterConfig) => {
    const { locale } = appContext;

    return config[locale];
  };

  const maintenanceConfig = computed(() => {
    const { tours_maintenance_toaster: maintenanceConfig } =
      firebase.remoteConfig;

    if (!maintenanceConfig) {
      return null;
    }
    return getLocalizedConfig(maintenanceConfig);
  });
</script>
